// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"535":"login","826":"index"}[chunkId] + ".20230911114927.js";
};